import { Vehicle as Result } from "@shared/platform-api/generated"
import { kmToMileConverterWithDecimals } from "@shared/utils/formatters/kmToMiles"
import { getSpeedBands, getSpeedingPercentage } from "../utils"
import { TripVehicle } from "./types"

export const fromApi = (result: Result): TripVehicle => {
  const speedBands = getSpeedBands(
    result.currentPeriod?.minorSpeedBandPercentage ?? null,
    result.currentPeriod?.majorSpeedBandPercentage ?? null,
    result.currentPeriod?.criticalSpeedBandPercentage ?? null
  )
  return {
    vrn: result.vrn,
    name: result.name ?? ``,
    currentPeriod: result.currentPeriod
      ? {
          score: result.currentPeriod.safetyScore ?? null,
          speedBands,
          distance: kmToMileConverterWithDecimals(result.currentPeriod.distanceKm, 1),
          distanceSpentSpeeding: getSpeedingPercentage(speedBands),
          averageSpeedExceedencePercentage: result.currentPeriod.averageSpeedExceedencePercentage ?? null,
        }
      : null,
    previousPeriodScore: result.previousPeriod?.safetyScore ?? null,
    totalSafetyScore: result.total?.safetyScore ?? null,
    totalDistance: result.total?.distanceKm ? kmToMileConverterWithDecimals(result.total?.distanceKm, 1) : null,
    vehicleType: result.vehicleType,
  }
}
